module.exports = __webpack_public_path__ + "media/images/emblems/Frauenkappelen-coat_of_arms-ed6613a72984a74a28af56fb8caecafb.svg";